import React from 'react'
import styles from './deleted-answer.module.scss'
import { ANSWER_HEIGHT } from 'state/PanelState'
import cn from 'classnames'
import { getCachedAnswer } from 'state/cache'
import api from 'api/api'
import { v4 as uuid } from 'uuid'
import useStore from 'state/knovStore'
import { isMobile } from 'lib/device'
import { getSwiperRef, isPanelRight } from 'state/imperativeApis/swiperApi'
import { BSV_TX_STATES } from 'utils/bsvTransactionStatus'
import { bsvTxExplorerUrl } from 'utils/bsvExplorerUrls'
import BsvTransactionStatusIcon from 'components/shared/BsvTransactionStatusIcon'
import { Answer } from 'types/answers'

interface DeletedAnswerProps {
    answerId: string
    answer?: Answer
    isTitle?: boolean
    onClickTitle?: (ev: React.MouseEvent) => void
    toggleSelectedAnswer?: (ev: React.MouseEvent) => void
    canToggle?: (ev: React.MouseEvent) => boolean
    insertRight?: (params: Record<string, unknown>) => void
    panelContext?: Record<string, unknown>
}

const DeletedAnswer: React.FC<DeletedAnswerProps> = ({
    answerId,
    answer: propsAnswer,
    isTitle,
    onClickTitle,
    toggleSelectedAnswer,
    canToggle,
    insertRight,
    panelContext,
}) => {
    // Get the cached answer data to access BSV transaction info
    const answer = propsAnswer || getCachedAnswer(answerId)
    const bsvTx = answer?.bsv_tx
    const txId = bsvTx?.tx_id

    // Check if this deleted answer has a child quest (is a parent)
    const hasChildQuest = answer?.child_quests?.length > 0

    const renderBsvTxStatus = () => (
        <BsvTransactionStatusIcon
            bsvTx={bsvTx}
            fallbackTxId={txId}
            className={styles.blockchainControl}
            stateClassNameMap={{
                [BSV_TX_STATES.AWAITING_RESUBMISSION]: styles.notOnchain,
                [BSV_TX_STATES.AWAITING_CONFIRMATION]: styles.notOnchain,
            }}
            wrapperProps={{
                href: bsvTxExplorerUrl(txId),
                target: '_blank',
                rel: 'noopener noreferrer',
                onClick: ev => ev.stopPropagation(),
            }}
        />
    )

    const handleClick = async (ev: React.MouseEvent) => {
        // Handle title clicks for parent answers
        if (isTitle && onClickTitle && hasChildQuest) {
            onClickTitle(ev)
            return
        }

        // Handle regular answer clicks that have child quests
        if (!isTitle && hasChildQuest && toggleSelectedAnswer) {
            toggleSelectedAnswer(ev)
        }
    }

    const clickable = (isTitle && hasChildQuest) || (!isTitle && hasChildQuest)

    return (
        <div
            className={cn(styles.deletedAnswer, clickable && styles.clickable)}
            data-answer-id={answerId}
            style={{ minHeight: ANSWER_HEIGHT }}
            onClick={clickable ? handleClick : undefined}
        >
            {(bsvTx || txId) && <div className={styles.topControls}>{renderBsvTxStatus()}</div>}
            <div className={styles.deletedContent}>DELETED</div>
        </div>
    )
}

export default DeletedAnswer
